import React from 'react';
import { FormattedMessage } from 'react-intl';

const DEFAULT_LOGO = "https://mdlive.azureedge.net/affiliations-prod/static_asset/logos/mdlivev2-logo.png"

const Header = ({logoUrl, logoHeight}) => (
  <header className="Header container pt-3 pb-3">
    {logoUrl ? (
      <img src={logoUrl} style={{height: `${logoHeight || 40}px`}} alt="logo"/>
    ) : (
      <a href={WORDPRESS_BASE_URL}>
        <img src={DEFAULT_LOGO} style={{height: '32px'}} alt="logo"/>
      </a>
    )}
  </header>
)

export default Header;



// WEBPACK FOOTER //
// ./registration-react/components/Header/Header.js